import { render, staticRenderFns } from "./ProjectServices.vue?vue&type=template&id=cbc1fe3a&"
import script from "./ProjectServices.vue?vue&type=script&lang=js&"
export * from "./ProjectServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbc1fe3a')) {
      api.createRecord('cbc1fe3a', component.options)
    } else {
      api.reload('cbc1fe3a', component.options)
    }
    module.hot.accept("./ProjectServices.vue?vue&type=template&id=cbc1fe3a&", function () {
      api.rerender('cbc1fe3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectServices.vue"
export default component.exports